import _ from 'lodash/fp'
import {callIfFunction} from '@startlibs/utils'

export const SERVER_ERROR = 'The communication with the server has failed, please check your connection and try again'

const onEmpty = (success,errors) => Object.keys(errors).length ? errors : success

export const onlyIf = (key,fn,validation) => (s,k,props) => fn(_.get(key,props)) ? validation(s,k,props) : false

export const onlyIfEqual = (key,equal,validation) => onlyIf(key,(v) => v === equal,validation)
export const onlyIfNotEqual = (key,equal,validation) => onlyIf(key,(v) => v !== equal,validation)

export const required = (s, _k,_props) => !s && 'Required field(s).'
export const intlRequired = (intl) => (s, _k,_props) => !s && intl.formatMessage({
  defaultMessage:'Required field(s).',
  description:'Validation error message for required fields'
})
export const booleanRequired = (s, _k) => required(s === true || s === false)
export const intlBooleanRequired = (intl) => (s, _k, _props) =>
  !(s === true || s === false) &&
    intl.formatMessage({
      defaultMessage: 'Required field(s).',
      description:'Validation error message for required fields'
    })
;
export const minLength = (n) => (s, _k) => s && s.length < n && `Field must have at least ${n} characters.`
export const maxLength = (n) => (s) => s && s.length > n && `Field cannot exceed ${n} characters.`

// Validation to check if the endDate is bigger than the startDate
export const dateAfter = (intl) => (dateKey) => (endDate, k, props) => _.get(dateKey,props) && endDate && endDate < _.get(dateKey,props) && intl.formatMessage({
  defaultMessage:'End date must be after start date.',
  description:'Validation error message for end date before start date'
})

export const confirmPasswords = (passwordKey) => (confirm, k, props) => (props[passwordKey] || confirm) && props[passwordKey] !== confirm && 'Passwords do not match.'
export const confirmEmails = (emailKey) => (confirm, k, props) => (_.get(emailKey,props) || confirm) && _.get(emailKey,props) !== confirm && 'Emails do not match.'
export const intlConfirmEmails = (intl) => (emailKey) => (confirm, k, props) => (_.get(emailKey,props) || confirm) && _.get(emailKey,props) !== confirm && intl.formatMessage({
    defaultMessage: 'Emails do not match.',
    description: 'Validation error message for email confirmation mismatch'
})

export const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
export const emailValidation = (s, _k) => !emailRegex.test(s?.trim()) && 'Invalid email address.'
export const intlEmailValidation = (intl) => (s, _k) => !emailRegex.test(s?.trim()) && intl.formatMessage({
  defaultMessage: 'Invalid email address.',
  description: 'Validation error message for invalid email address'
})

export const optional = (cb) => (v,...args) => v ? cb(v,...args) : false

export const buildValidation = (validations,custom = () => {}) => (props) =>
  onEmpty(false,
    {
      ..._.flow(
        _.entries,
        _.map(([k, v]) => [k, [].concat(v).map(fn => callIfFunction(fn,_.get(k, props), k, props)).filter(_ => _)]),
        _.filter(([, v]) => v.length),
        _.fromPairs
      )(validations),
      ...callIfFunction(custom,props)
    }
  )


export const responseFailure = (fn = _.identity) => (_,response,{setErrors}) => {
  const errorSetter = setErrors
  const r = [].concat(response,_)
  console.log(r)
  const error = fn(...r)
  if (error === true) {
  } else if (error) {
    errorSetter(error)
  } else {
    errorSetter({"":[SERVER_ERROR]})
  }
}
